import React from 'react'

const Resmed = () => {
  return (
    <div className='bg-[#F3F4F8] grid lg:grid-cols-5 md:grid-cols-3 grid-cols-3 gap-5 px-20 py-10'>
        <img className="w-[80px] h-[30px]  " src={require("../assets/Group 1205.png")} alt=""  />
        <img className="w-[80px] h-[30px]  " src={require("../assets/Group 1206.png")} alt=""  />
        <img className="w-[80px] h-[30px]   " src={require("../assets/image 52.png")} alt=""  />
        <img className="w-[80px] h-[30px]   " src={require("../assets/layer1.png")} alt=""  />
        <img className="w-[80px] h-[30px]    " src={require("../assets/Group 1209.png")} alt=""  />
        <img className="w-[80px] h-[30px]  " src={require("../assets/Group 1210.png")} alt=""  />
        <img className="w-[80px] h-[30px]  " src={require("../assets/image 54.png")} alt=""  />
        <img className="w-[80px] h-[30px]    " src={require("../assets/image 55.png")} alt=""  />
        <img className="w-[80px] h-[30px]   " src={require("../assets/Group 1211.png")} alt=""  />
    </div>
  )
}

export default Resmed
